import { Component, OnInit } from "@angular/core";
import { environment } from "../../../../environments/environment";

@Component({
    selector: "app-pyme",
    templateUrl: "./pyme.component.html",
    styleUrls: ["./pyme.css"],
})
export class PymeComponent implements OnInit {
    ngOnInit(): void {
        //  throw new Error("Method not implemented.");
    }

    mobile: any;
    urlPyme = environment.URL_NEGOCIOS_PYME_HOGAR;

    constructor() {}

    redirec() {
        window.location.assign(this.urlPyme);
    }
}
